// contexts/AuthContext.js
import React, { createContext, useState, useEffect, useContext } from "react";
import { app } from "../App"; // Only import the app, not auth

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [currentUser, setCurrentUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [authInitialized, setAuthInitialized] = useState(false);

  useEffect(() => {
    let unsubscribe = () => {};

    const initAuth = async () => {
      // Wait for page to fully load first (don't block LCP)
      if (document.readyState !== 'complete') {
        await new Promise(resolve => 
          window.addEventListener('load', resolve, { once: true })
        );
      }

      // Additional delay to ensure LCP is measured
      await new Promise(resolve => {
        if ('requestIdleCallback' in window) {
          requestIdleCallback(resolve, { timeout: 300 });
        } else {
          setTimeout(resolve, 150);
        }
      });

      // Now dynamically import and initialize auth
      const { getAuth, onAuthStateChanged } = await import('firebase/auth');
      const auth = getAuth(app);

      unsubscribe = onAuthStateChanged(auth, (user) => {
        setCurrentUser(user);
        setLoading(false);
        setAuthInitialized(true);
      });
    };

    initAuth();

    return () => unsubscribe();
  }, []);

  return (
    <AuthContext.Provider value={{ currentUser, loading, authInitialized }}>
      {children} {/* Always render children immediately! */}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  return useContext(AuthContext);
};